<div class="py-px-16 px-px-32 ">
  <div class="d-flex justify-content-between">
    <div class="fs-20 fw-7">{{ data.isModify ? 'Mettre à jour les détails' : 'Ajouter un site' }}</div>
    <div>
      <svg-icon src="assets/icons/close.svg" class="cursor-pointer" (click)="dialogRef.close()"></svg-icon>
    </div>
  </div>
  <div class="site-container">


    <app-custom-input label="Nom du site" [parentForm]="form" controlName="name"
                      [required]="true" innerClass="mt-px-16"></app-custom-input>

    <div class="my-3 w-100" [formGroup]="form" >
      <!-- <app-custom-input [label]="'Adresse du site'" [parentGroupName]="'{{$index}}'" [parentForm]="thirdStepFormControl"  type="autocomplete" [options]="etablissementType" controlName="addressSite"  [required]="true" ></app-custom-input> -->
      <mat-label>Adresse du site <span class="required">*</span></mat-label>
      <input type="text"
             class="w-100"
             (input)="autoCompleteOnChange($event.target)"
             [matAutocomplete]="auto"
             formControlName="address"
                autocomplete="off"
      >
      <mat-autocomplete #auto="matAutocomplete"    autocomplete="off">
        @for (option of addressList; track option) {
          <mat-option [value]="getAdresseFormated(option)" (onSelectionChange)="addressSelected(option)">{{ getAdresseFormated(option) }}</mat-option>
        }
      </mat-autocomplete>
      <div class="required"
           *ngIf="form?.get('adress')?.touched
                   && (form?.get('adress')?.errors ||
                   form?.get('regionCode')?.errors)
                ">
        Veuillez saisir une addresse valide de la liste (En France)
      </div>
    </div>
    <div class="d-flex justify-content-between gap-4 w-100 mt-px-16">
      <div class="w-100">
        <app-custom-input [parentForm]="form" controlName="pays" label="Pays" [required]="true"></app-custom-input>
      </div>
      <div class="w-100">
        <app-custom-input label="Code postal" [parentForm]="form" controlName="codePostale"
                          [required]="true"></app-custom-input>
      </div>
    </div>

    <div class="d-flex justify-content-between gap-4 w-100 mt-px-16">
      <div class="w-100">
        <app-custom-input label="Ville" [parentForm]="form" controlName="ville"
                          [required]="true"></app-custom-input>
      </div>
      <div class="w-100">
        <app-custom-input label="Département" [parentForm]="form" controlName="departmentName"
                          [required]="true"></app-custom-input>
      </div>
    </div>

    <app-custom-input label="CEDEX" [parentForm]="form" controlName="cedex" type="number"
                       innerClass="col-6 mt-px-16 pe-2"
                      errorMessage="CEDEX doit avoir 2 caractères"></app-custom-input>
    <div class="mt-px-10">{{ EtablissementData.monEtablissement.photoDescription }}</div>
    <div class="mt-px-8">{{ EtablissementData.monEtablissement.addAfter }}</div>



    <app-custom-dragdrop-image
      (sendImage)="getImage($event)"
      [url]="addressImages"
      [isDeletble]="true"
      [limit]="2"
    ></app-custom-dragdrop-image>


  </div>
  <mat-dialog-actions align="end" class="mt-px-24">
    <app-button (handleClick)="dialogRef.close()" [stroked]="true" text="Annuler"></app-button>
    <app-button (handleClick)="addSite()" [loading]="loading" [disabled]="form.invalid" innerClass="ml-px-8"
                [text]=" data.isModify ? 'Confirmer les changements': 'Ajouter ce site'"></app-button>
  </mat-dialog-actions>
</div>
